
import { mapGetters, mapMutations } from 'vuex'
import { setupTranslationPrefixer } from '~/assets/translation'

export default {
  props: {
    page: { type: Object, required: false, default: undefined },
  },
  setup(props) {
    return {
      ...setupTranslationPrefixer('ControlPanel'),
    }
  },
  data() {
    return {
      isOpen: this.isOpen,
    }
  },
  computed: {
    ...mapGetters({
      isEnabled: 'control-panel/isEnabled',
    }),
    urls() {
      return Object.entries(this.page?.controlPanel || {})
        .filter(([label, url]) => typeof url === 'string' && /^https?:\/\//i.test(url))
        .map(([label, url]) => ({ label, url }))
    },
  },
  created() {
    if (process.client) {
      if (/yes|true|1/.test(this.$route.query.cp)) {
        this.$store.commit('control-panel/enable')
      }
    }
  },
  methods: {
    ...mapMutations({
      reset: 'control-panel/reset',
      toggle: 'control-panel/toggle',
    }),
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
  },
}
